export const service =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_SERVICE
    : process.env.REACT_APP_PROD_SERVICE;
